import { render, staticRenderFns } from "./FactBox.vue?vue&type=template&id=1606550c&"
import script from "./FactBox.vue?vue&type=script&lang=js&"
export * from "./FactBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports